import { TAuth, TAuthActions, TGetLoginReqPaylod, TRole } from '../../types/auth';

export const authActionTypes = {
  GET_TRY_LOGIN_REQ: 'AUTH/GET_TRY_LOGIN_REUQEST',
  SET_LOADING: 'AUTH/SET_LOADING',
  SET_REGISTER_LOADING: 'AUTH/REGISTER_LOADING',
  SET_REGISTER_TOKEN: 'AUTH/SET_REGISTER_TOKEN',
  GET_LOGIN_REQUEST: 'AUTH/GET_LOGIN_REQUEST',
  GET_LOGIN_SUCCESS: 'AUTH/GET_LOGIN_SUCCESS',
  GET_LOGIN_ERROR: 'AUTH/GET_LOGIN_ERROR',
  CLEAR_REGISTER_DATA: 'AUTH/CLEAR_REGISTER_DATA',
  GET_REGISTER_REQUEST: 'AUTH/GET_REGISTER_REQUEST',
  SET_REGISTER_ERROR: 'AUTH/SET_REGISTER_ERROR',
  RESET_LOGIN_ERROR: 'AUTH/RESET_LOGIN_ERROR',
  GET_CODE_VERIFY_REQUEST: 'AUTH/GET_CODE_VERIFY_REQUEST',
  SET_ROLE: 'AUTH/SET_ROLE',
  GET_RESEND_EMAIL_REQUEST: 'AUTH/GET_RESEND_EMAIL_REQUEST',
  SET_HAS_RESENT_EMAIL: 'AUTH/SET_HAS_RESENT_EMAIL',
  GET_RESENT_EMAIL_ERROR: 'AUTH/GET_RESENT_EMAIL_ERROR',
  GET_RESEND_PHONE_REQUEST: 'AUTH/GET_RESEND_PHONE_REQUEST',
  SET_HAS_RESENT_PHONE: 'AUTH/SET_HAS_RESENT_PHONE',
  GET_RESENT_PHONE_ERROR: 'AUTH/GET_RESENT_PHONE_ERROR',
  ADD_REGISTER_DATA: 'AUTH/ADD_REGISTER_DATA',
  SET_CURRENT_REG_STEP: 'AUTH/SET_CURRENT_REG_STEP',
  SET_LOGIN_LOADING: 'AUTH/SET_LOGIN_LOADING',
} as const;

const initialState: TAuth = {
  isLogged: false,
  isLoading: true,
  loginError: '',
  registerData: {},
  registerError: '',
  registerLoading: false,
  registerToken: '',
  role: 'patient',
  hasResentEmail: false,
  resentEmailError: '',
  hasResentPhone: false,
  resentPhoneError: '',
  currentRegStep: 0,
  loginLoading: false,
};

export default (state: TAuth = initialState, action: TAuthActions): TAuth => {
  switch (action.type) {
    case authActionTypes.GET_LOGIN_SUCCESS:
      return {
        ...state,
        isLogged: action.payload,
      };
    case authActionTypes.ADD_REGISTER_DATA:
      return {
        ...state,
        registerData: action.payload,
      };

    case authActionTypes.SET_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    case authActionTypes.GET_LOGIN_ERROR:
      return {
        ...state,
        loginError: action.payload,
      };

    case authActionTypes.SET_REGISTER_ERROR:
      return {
        ...state,
        registerError: action.payload,
      };

    case authActionTypes.SET_REGISTER_LOADING:
      return {
        ...state,
        registerLoading: action.payload,
      };

    case authActionTypes.GET_REGISTER_REQUEST:
      return {
        ...state,
        registerData: {
          ...state.registerData,
          ...action.payload,
        },
      };

    case authActionTypes.CLEAR_REGISTER_DATA:
      return {
        ...state,
        registerData: {},
      };

    case authActionTypes.SET_REGISTER_TOKEN:
      return {
        ...state,
        registerToken: action.payload,
      };

    case authActionTypes.RESET_LOGIN_ERROR:
      return {
        ...state,
        loginError: '',
      };

    case authActionTypes.SET_ROLE:
      return {
        ...state,
        role: action.payload,
      };

    case authActionTypes.SET_HAS_RESENT_EMAIL:
      return {
        ...state,
        hasResentEmail: action.payload,
      };

    case authActionTypes.GET_RESENT_EMAIL_ERROR:
      return {
        ...state,
        resentEmailError: action.payload,
      };

    case authActionTypes.SET_HAS_RESENT_PHONE:
      return {
        ...state,
        hasResentPhone: action.payload,
      };

    case authActionTypes.GET_RESENT_PHONE_ERROR:
      return {
        ...state,
        resentPhoneError: action.payload,
      };

    case authActionTypes.SET_CURRENT_REG_STEP:
      return {
        ...state,
        currentRegStep: action.payload,
      };
    case authActionTypes.SET_LOGIN_LOADING:
      return {
        ...state,
        loginLoading: action.payload,
      };

    default:
      return state;
  }
};

export const actions = {
  getLoginRequest: (payload: TGetLoginReqPaylod) => ({
    payload,
    type: authActionTypes.GET_LOGIN_REQUEST,
  }),
  getTryLoginRequest: () => ({ type: authActionTypes.GET_TRY_LOGIN_REQ }),
  getRegisterRequest: (payload: any) => ({
    payload,
    type: authActionTypes.GET_REGISTER_REQUEST,
  }),
  resetLoginError: () => ({ type: authActionTypes.RESET_LOGIN_ERROR }),
  setRegisterToken: (token: string) => ({
    type: authActionTypes.SET_REGISTER_TOKEN,
    payload: token,
  }),
  clearRegisterData: () => ({ type: authActionTypes.CLEAR_REGISTER_DATA }),
  getPhoneCodeVerifyRequest: (payload: string) => ({
    payload,
    type: authActionTypes.GET_CODE_VERIFY_REQUEST,
  }),
  setRole: (payload: TRole) => ({ payload, type: authActionTypes.SET_ROLE }),
  getResendEmailRequest: () => ({ type: authActionTypes.GET_RESEND_EMAIL_REQUEST }),
  getResendPhoneRequest: () => ({ type: authActionTypes.GET_RESEND_PHONE_REQUEST }),
  setCurrentRegStep: (payload: number) => ({ type: authActionTypes.SET_CURRENT_REG_STEP, payload }),
  setRgisterError: (payload: string) => ({
    type: authActionTypes.SET_REGISTER_ERROR,
    payload,
  }),
};
